<template>
  <div class="agave-main">
    <span id="title">{{ $t('agaveLookup')}}</span>
    <SearchBar 
      :searchPrompt="searchPrompt"
      :firstDataSet="commonNames"
      firstDataSetName="commonNames"
      :secondDataSet="speciesNames" 
      secondDataSetName="speciesNames"
      @searchSelected="findResultInfo"
    />
    <AgaveInfo 
      :searchResult="searchResult"
      :correspondingNames="correspondingNames"
      @searchSelected="findResultInfo"
    />
    <div id="agave-background-container" :class="{ isHidden: backgroundIsHidden}">
      <img class="agave-background" src="@/assets/images/agave.svg" :class="{ isHidden: backgroundIsHidden}"/>
    </div>
  </div>
</template>

<script>
// import {commonNames, speciesNames, subspeciesNames, commonToSpecies} from "@/assets/JSON/data.js"
import SearchBar from "@/components/SearchBar.vue"
import AgaveInfo from "@/components/AgaveInfo.vue"

export default {
  name: 'Agave',
  components: {
    SearchBar,
    AgaveInfo
  },
  computed: {
    searchPrompt(){
      if (this.$i18n.i18next.language === 'en'){
        return 'search by species or common name'
      } else {
        return 'buscar por especie o nombre común'
      }
    }
  },
  data(){
    return {
      commonNames: [],
      speciesNames: [],
      subspeciesNames: [],
      commonToSpecies: [],
      backgroundIsHidden: false,
      searchResult: {
        name: '',
        language: '',
        label: '',
        subspecies: [],
      },
      correspondingNames: [],
    }
  },
  async mounted (){
    this.commonNames = await this.$getItem('commonNames');
    this.speciesNames = await this.$getItem('speciesNames');
    this.subspeciesNames = await this.$getItem('subspeciesNames')
    this.commonToSpecies = await this.$getItem('commonToSpecies');
  },
  methods: {
    sortByName(a, b) {
      if (a.name < b.name){
        return -1;
      }

      if (a.name > b.name){
        return 1;
      }
      return 0;
    },
    findResultInfo(searchResult){
      this.searchResult = searchResult;

      if (searchResult.setName === "commonNames"){
        this.searchResult.label = "Species names:"

        const joiningIds = this.commonToSpecies.filter(entry => searchResult.id === entry.common_id);
        const speciesIds = joiningIds.map(join => join.species_id);
        const unorderedResults = this.speciesNames.filter(species => speciesIds.includes(species.id));
        unorderedResults.forEach(element => element.setName = "speciesNames");


        this.correspondingNames = unorderedResults.sort(this.sortByName);

        
      } else if (searchResult.setName === "speciesNames"){
        this.searchResult.language = "Species";
        this.searchResult.label = "Common names:"

        const joiningIds = this.commonToSpecies.filter(entry => searchResult.id === entry.species_id);
        const subspeciesIds = joiningIds.map(join => join.subspecies_id);
        const commonIds = joiningIds.map(join => join.common_id);
        const unorderedResults = this.commonNames.filter(common => commonIds.includes(common.id));
        unorderedResults.forEach(element => element.setName = "commonNames");

        const unorderedSubspecies = this.subspeciesNames.filter(sub => subspeciesIds.includes(sub.id));
        this.searchResult.subspecies = unorderedSubspecies.sort(this.sortByName)

        this.correspondingNames = unorderedResults.sort(this.sortByName);
      }
    }
  },
  watch: {
    searchResult(newValue){
      if (newValue.name != ''){
        this.backgroundIsHidden = true;
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.agave-main {
  margin: 10px;
}

h1 {
  font-family: 'futura';
  font-size: 28px;
  margin-top: 20px;
  margin-bottom: 0;
}

span {
  font-family: 'avenir'
}

.heading {
  font-family: 'optima';
  font-size: 18px;
  font-weight: 100;
}

#title {
  color: grey;
}

.agave-background {
  width: 90vw;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15vh;
  filter: invert(.6);
  position: absolute;
}

#agave-background-container {
  top: 150px;
  z-index: -1;
  position: absolute;
}

#agave-background-container.isHidden, .agave-background.isHidden {
  display: none;
}

</style>